import {
    useMemo,
} from 'react'
import {
    Navigate,
} from 'react-router-dom'

import PreBookings from 'app/common/PreBooking'

import {
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'
import Pooling from './Pooling'
import DailyOps from './DailyOps'
import OpenBookings from './OpenBookings'
import Lanes from './Lanes'
import CustomerTransport from './Orders/CustomerTransport'
import InternalTransport from './Orders/InternalTransport'
import FreightForwarders from './FreightForwarders'
import LongTermLease from './LongTermLease'
import ProformaInvoices from './ProformaInvoices'

export default function OrderManagement() {
    const Routes = useOrderManagementRoutes()

    const routesConfig = useMemo(() => {
        return {
            [Routes.DailyOps.route]: <DailyOps />,
            [Routes.Pooling.route]: <Pooling />,
            [Routes.OpenBookings.route]: <OpenBookings />,
            [Routes.Lanes.route]: <Lanes />,
            [Routes.CustomerOrders.route]: <CustomerTransport />,
            [Routes.InternalOrders.route]: <InternalTransport />,
            [Routes.FreightForwarders.route]: <FreightForwarders />,
            [Routes.LongTermLease.route]: <LongTermLease />,
            [Routes.PreBookings.route]: <PreBookings />,
            [Routes.ProformaInvoices.route]: <ProformaInvoices />,
            [CommonRoutes.Slash]: <Navigate
                to={Routes.DailyOps.route}
                replace
            />,
        }
    }, [Routes])

    return useSkyNetRoutes({
        routesConfig,
    })
}
